import React from 'react'
import styled from 'styled-components'
import {Link} from 'gatsby'
import { ContainerFullWidth, ContainerBodyWidth } from '../containers'
import { navList, socialList } from './header'

import { FaGithub, FaDribbble, FaLinkedin, FaTwitter } from "react-icons/fa";

const FooterContainerFullWidth = styled(ContainerFullWidth)`
  background-color: ${ props => props.theme.theme.bg.tertiary};
  /* background-color: ${ props => props.theme.theme.colors.footerBg}; */
  border-top: 1px solid ${ props => props.theme.theme.border.secondary};
  padding: 0 0 48px 0;

  p{
    margin: 12px 0 0 0;
  }
`

const FooterBody = styled(ContainerBodyWidth)`
  padding: 24px 24px 12px 24px;
  box-sizing: border-box;
  color: ${props => props.theme.theme.text.tertiary};

  p {
    a{
      color: ${props => props.theme.theme.text.tertiary};
      /* border-bottom: 2px solid ${props => props.theme.theme.border.secondary}; */

      &:hover {
        border-bottom: 2px solid ${props => props.theme.theme.colors.blue};
      }
    }
  }

`

const FooterGrid = styled(ContainerBodyWidth)`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: auto auto 1fr;
  align-items: start;
  justify-items: left;
  /* margin: -20px 0 0 0; */
  /* padding: 24px 24px 12px 24px; */
  /* color: white; */

  a {
    color: ${props => props.theme.theme.text.tertiary};
    /* color: white; */
    text-decoration: none;
    font-size: 1rem;
    /* text-transform: uppercase; */

    &:hover {
      color: ${props => props.theme.theme.text.primary};
    }
  }

  span {
    font-weight: 600;
    margin: 0;
    font-size: 1rem;
  }

  .bold{
    font-weight: 600;
  }

  .logo {
    color: ${props => props.theme.theme.colors.green};
    text-transform: uppercase;
  }

  p {
    font-family: 'Inter', sans-serif;
  }

  ul{
    /* display: flex; */
    list-style-type:none;
    margin: 0;
    padding: 0;
    font-family: 'Inter', sans-serif;

    li{
      margin: 10px 10px 0 0px;
      a {
        /* color: ${props => props.theme.theme.text.secondary}; */

        &:hover {
          color: ${props => props.theme.theme.text.primary};
        }
      }
    }
  }

  @media (min-width: 401px) and (max-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 400px){
    grid-template-columns: 1fr;
  }
`

const Social = styled.div`
  height: 100%;
  justify-self: right;
  display: grid;
  justify-items: right;
  align-content: space-between;

  p{
    text-align: right;
  }

  @media (max-width: 600px){
    justify-self: left;
    justify-items: left;

    p{
      text-align: left;
    }
  }
`


const Footer = ( { logoText, projects } ) => {
  const linksList = (<ul>
    <li>
      <Link to='/articles/'>Articles</Link>
    </li>
    <li>
      <Link to='/tools/'>Tools</Link>
    </li>
    <li>
      <Link to='/about/'>About</Link>
    </li>
    <li>
      <Link to='/newsletter/'>Newsletter</Link>
    </li>
    <li>
      How to support me: <a href="https://www.buymeacoffee.com/walletburst" target="_blank">☕️ Buy Me a Coffee</a> or <a href="https://amzn.to/3xKWm0R" target="_blank">Shop with my Amazon link</a>
    </li>
    {/* <li>
      <Link to='/reviews/'>Reviews</Link>
    </li>
    <li>
      <Link to='/tools/'>Remote Tools</Link>
    </li>
    <li>
        <Link to='/about/'>About</Link>
    </li> */}
  </ul>)

  console.log(projects)

  return(
    <FooterContainerFullWidth>
      <FooterBody>
        <FooterGrid>
          <div>
            <Link to='/'>
              <span className='bold logo' >{ logoText }</span>
            </Link>
            {linksList}
          </div>

          <div>
          </div>

          <Social>
            {socialList}
            <div>
              <p>
                Google <a href='https://policies.google.com/privacy' target="_blank" rel="noopener">Privacy Policy </a>
                and <a href="https://policies.google.com/terms" target="_blank" rel="noopener">Terms of Service</a> apply.
              </p>
              {/* <p>
                As an Amazon Associate I earn from qualifying purchases.
              </p> */}
              <p>All images used with permission.</p>
            </div>
          </Social>

        </FooterGrid>

      </FooterBody>
    </FooterContainerFullWidth>
  )

}

export default Footer
